<script setup lang="ts">
defineProps<{ compact?: boolean }>();
</script>

<template>
  <span class="brand-lockup" :class="{ compact }" aria-label="GameGlee">
    <span class="brand-mark" aria-hidden="true">g.</span>
    <span v-if="!compact" class="brand-word">GameGlee.</span>
  </span>
</template>
